/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/* eslint-disable no-param-reassign */
import { types } from 'mobx-state-tree';

export default types.model('BulkPublishReqId', {
  id: types.optional(types.identifier, () =>
    Math.random().toString(36).substring(2, 9)
  ),
  operationType: types.optional(types.string, 'Publish'),
  title: types.maybeNull(types.string),
  userid: types.maybeNull(types.string),
  publishInitiateTime: types.maybeNull(types.string),
  startTime: types.maybeNull(types.string),
  endTime: types.maybeNull(types.string),
  errorDetails: types.maybeNull(types.string),
  status: types.enumeration([
    'Processing',
    'Completed',
    'Error',
    'Queued',
    'In Progress',
    'Failed'
  ]),
  progress: types.maybeNull(types.number, 0),
  total: types.maybeNull(types.number, 0),
  completed: types.maybeNull(types.number, 0),
  bulkRequestId: types.maybeNull(types.string),
  statuses: types.optional(types.array(types.string), [])
});
